import { REFERENCE_NUMBER } from '../../constants/referenceNumber'

export const useURL = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const referenceNumber = searchParams.get(REFERENCE_NUMBER)
  const urlWithoutSearchParams = `${window.location.origin}${window.location.pathname}`

  const handleUpdateURLWithoutReload = () => {
    if ((referenceNumber || '')?.length > 0) {
      window.history.pushState({}, '', urlWithoutSearchParams)
    }
  }

  const handleUpdateURLWithReload = () => {
    if ((referenceNumber || '')?.length > 0) {
      window.location.href = urlWithoutSearchParams
    } else {
      window.location.reload()
    }
  }

  return {
    referenceNumber,
    handleUpdateURLWithoutReload,
    handleUpdateURLWithReload,
  }
}
